function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import classnames from 'classnames';
import React, { useMemo } from 'react';
import { ProgressBar } from 'react-bootstrap';
import { calculateRemainderDays, calculateRemainderHours, calculateTrialLengthDays } from '../../utilities/membership';
var TrialMembershipBar = function(_param) {
    var membership = _param.membership, restProps = _object_without_properties(_param, [
        "membership"
    ]);
    var _useMemo = useMemo(function() {
        var variant = 'success';
        var trialLengthDays = calculateTrialLengthDays(membership);
        var remainderHours = calculateRemainderHours(membership);
        var remainderDays = calculateRemainderDays(membership);
        if (remainderDays <= 4 && remainderHours > 24) {
            variant = 'warning';
        } else if (remainderHours <= 24) {
            variant = 'danger';
        }
        // Allow for hours to show on progress bar
        if (remainderDays === 0) {
            remainderDays = remainderHours / 24;
        }
        return {
            variant: variant,
            remainderDays: remainderDays,
            trialLengthDays: trialLengthDays
        };
    }, [
        membership
    ]), variant = _useMemo.variant, trialLengthDays = _useMemo.trialLengthDays, remainderDays = _useMemo.remainderDays;
    return /*#__PURE__*/ React.createElement(ProgressBar, _object_spread({
        className: classnames('inverted', _define_property({}, variant, variant)),
        now: (trialLengthDays - remainderDays) / trialLengthDays * 100,
        variant: variant
    }, restProps));
};
export default TrialMembershipBar;
